<template>
    <div class="widget-picker">
        <widget-group v-bind="$attrs" v-on="$listeners" />
    </div>
</template>

<script>
import WidgetPreview from './WidgetPreview.vue'
import WidgetGroup from './WidgetGroup.vue'

export default {
    name: 'widget-tray',
    components: { WidgetPreview, WidgetGroup }
}
</script>

<style lang="scss" scoped>
.widget-picker {
    ::v-deep .vs-sidebar {
        position: fixed;
        z-index: 1000000;
        width: 400px;
        max-width: 90vw;
        // @apply shadow-lg;
        box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
    }
}
</style>
